import {ApiProvider} from "@renta-apps/athenaeum-react-common";
import {IPagedList} from "@renta-apps/athenaeum-toolkit";
import {NewsItem} from "@/models/server/NewsItem";
import AcknowledgementInfo from "@/models/server/AcknowledgementInfo";
import GetNewsAcknowledgmentsRequest from "@/models/server/requests/GetNewsAcknowledgmentsRequest";

export const fetchNewsAsync = async (): Promise<NewsItem[]> => {
    return ApiProvider.getAsync<NewsItem[]>("/api/NewsAdmin/NewsItems", null);
}

export const fetchNewsActiveAsync = async (): Promise<NewsItem[]> => {
    return ApiProvider.postAsync<NewsItem[]>("/api/Application/GetNewsItems", null);
}

export const saveNewsItemAsync = async (item: NewsItem): Promise<NewsItem> => {
    return ApiProvider.postAsync<NewsItem>("/api/NewsAdmin/SaveNewsItem", item, null);
}

export const deleteNewsItemAsync = async (item: NewsItem): Promise<void> => {
    return ApiProvider.postAsync<void>("/api/NewsAdmin/DeleteNewsItem", item.id, null);
}

export const acknowledgeNewsAsync = async (newsId: string): Promise<void> => {
    // Only the news id is sent; the acknowledging user is derived server-side
    // from the authenticated caller (mirrors deleteNewsItemAsync).
    return ApiProvider.postAsync<void>("/api/Application/AcknowledgeNews", newsId, null);
}

export const fetchNewsAcknowledgmentsAsync = async (request: GetNewsAcknowledgmentsRequest): Promise<IPagedList<AcknowledgementInfo>> => {
    // Loaded on demand, one page at a time, only when the admin opens the "Read by" modal.
    return ApiProvider.postAsync<IPagedList<AcknowledgementInfo>>("/api/NewsAdmin/NewsAcknowledgments", request, null);
}
